module.exports = __webpack_public_path__ + "img/prize2_active.75095b1.png";